let apiUrl;
const expressPort = 3001;

const apiUrls = {
  production: "https://api.qiysak.com/api/v1",
  development: `http://localhost:${expressPort}/api/v1`,
};

if (
  window.location.hostname === "localhost" ||
  window.location.hostname.includes("192")
) {
  apiUrl = apiUrls.development
} else {
  apiUrl = apiUrls.production;
}

export default apiUrl;
